<template>
	<!-- 隐患记录 -->
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.companyName" placeholder="企业名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getPageList">查询</el-button>
				</el-form-item>
		
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="pagelist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			<el-table-column prop="checkNumber" label="检查编号" align="center" min-width="180">
			</el-table-column>
			<el-table-column prop="coName" label="企业名称" min-width="200" align="center">
			</el-table-column>
			<el-table-column prop="cityName" label="所属城市" min-width="100" align="center">
			</el-table-column>
      		<el-table-column prop="checkTime" label="检查时间" align="center" min-width="200">
			</el-table-column>
			<el-table-column prop="yhStatusName" label="隐患状态" align="center"  min-width="100">
			</el-table-column>
      		<el-table-column prop="correctDeadTime" label="整改期限" align="center"  min-width="150">
			</el-table-column>
			<el-table-column prop="correctTime" label="整改完成日期" align="center"  min-width="150">
			</el-table-column>
      		<el-table-column prop="correctContent" label="整改措施" align="center"  min-width="150">
			</el-table-column>
			<el-table-column prop="reviewTime" label="复查日期" align="center"  min-width="150">
			</el-table-column>
      		<el-table-column prop="reviewContent" label="复查说明" align="center"  min-width="150">
			</el-table-column>
			<el-table-column  label="操作" align="left" width="400">
				<template slot-scope="scope">					
					<el-button  type="primary"  size="small" @click="yhDetail(scope.$index, scope.row)">隐患详情</el-button>
					<el-button  v-if="scope.row.correctNoticeURL!=''" type="danger" size="small" @click="handleFileShow(scope.$index, scope.row)">整改通知书</el-button>
					<el-button  type="warning" size="small" @click="handleDownloadFile(scope.$index, scope.row)">下载整改材料</el-button>					
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--显示PDF 【责令整改通知书】-->
		<el-dialog :title="pdfFileName" v-model="pdfVisible" :close-on-click-modal="false" >
			<el-form>
				<iframe :src="pdfSrc" frameborder="0" style="width: 100%; height: 500px"></iframe>
			</el-form>
		</el-dialog>

		<!--详情界面-->
		<el-dialog  title="隐患详情" v-model="detailFormVisible" :close-on-click-modal="false">

			<div class="grid-content bg-purple">
				<label>企业名称:  {{detailForm.coName}}</label>
			</div>

			<div class="grid-content bg-purple-light">
				<label>检查编号:  {{detailForm.checkNumber}} </label>
			</div>

			<div class="grid-content">
				<label>检查时间:  {{detailForm.checkTime}} </label>
			</div>

			<div v-for="(item, index) in feedata" :key="index" style="margin-top: 20px;">
				<div class="grid-content bg-purple">
					<label>【{{item.checkType}}】{{item.checkContent}}</label>
				</div>
				<div class="grid-content bg-purple-light">
					<label>检查结果:  {{item.checkResult=='1'?'合格':'不合格'}} </label>
				</div>
				<div class="grid-content">
					<label>检查备注:  {{item.checkDesc}} </label>
				</div>
				<div class="image-container">
					<div v-for="picurl in item.picList" :key="picurl" class="image-item">
					<img :src="picbaseurl+picurl" alt="Image" @click.self="showBigImage(picbaseurl+picurl)">
					</div>
				</div>
				<hr>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click.native="detailFormVisible = false">关闭</el-button>
			</div>
		</el-dialog>

		<!--4-2显示放大图片的组件-->
		<BigImg :visible="photoVisible" :url="bigImgUrl" @closeClick="()=>{photoVisible=false}"></BigImg>

		

	</section>
</template>

<script>
	// 4-1 
	import BigImg from "../../components/big-img"
	import { gjCheckList,gjCheckDetailList} from '../../api/api';

	export default {
		components:{
			BigImg:BigImg
    	},
		data() {
			return {
				objectId:0, //当前登录的用户id，新增会用到
			
				filters: {
					companyName: ''
				},
				pagelist: [],
				total: 0,
				page: 1,
				listLoading: false,

				//隐患详情
				detailFormVisible: false,
				feedata: [],
				detailForm: {
					coName:"",
					checkNumber:"",
					checkTime: "",
				},

				//上传资料
				uploadstart:true,
				fcfile: null,

				picbaseurl:"https://aqjg.ycsyzglj.com/",

				// 显示pdf
				pdfVisible: false, 
				pdfSrc: '', // 将从后台获取到的 PDF 文件地址赋值给这个字段
				pdfFileName:"",
				// 正式地址
				filebaseurl:"https://aqjg.ycsyzglj.com/",

				// 4-5
				photoVisible:false,
				bigImgUrl:""
				
			}
		},
		methods: {
		 	handleDownloadFile: function (index, row) {
				if(row.correctFileURL!=""){
					let zipurl="https://aqjg.ycsyzglj.com/"+row.correctFileURL
					let a = document.createElement("a");//创建a标签
					a.setAttribute("href", zipurl);//设置文件下载地址
					a.setAttribute('target', '_blank');//在当前页面创建下载
					document.body.appendChild(a);//添加到body
					a.click();//触发事件
					document.body.removeChild(a);//移除标签
				}
			},
			handleFileShow: function (index, row) {
				this.pdfSrc=this.filebaseurl+row.correctNoticeURL
				this.pdfFileName=row.coName+" 责令整改通知书"
				this.pdfVisible=true
			},
			//4-4点击图片函数，点击后，把photoVisible设置成true
			showBigImage(e) {
				if (e != "") {
					this.photoVisible = true;
					this.bigImgUrl = e;
				}
			},
			handleCurrentChange(val) {				
				this.page = val;
				this.getPageList();
			},
			//获取分页列表
			getPageList() {
				let para = {
					page: this.page,
					pageSize:20,
					objectId:this.objectId,
					coName: this.filters.companyName,
					checkType:"record",
				};

				this.listLoading = true;

				gjCheckList(para).then((res) => {
					if(res.data.code==0){
						this.total = res.data.data.total;
						this.pagelist = res.data.data.list;
					}
					
					this.listLoading = false;

				});
			},
			
			
			yhDetail: function (index, row) {
				this.detailForm.coName=row.coName
				this.detailForm.checkNumber=row.checkNumber
				this.detailForm.checkTime=row.checkTime
				let para = {
					checkNumber: row.checkNumber
				};

				gjCheckDetailList(para).then((res) => {
					this.detailFormVisible=true
					if(res.data.code==0){
						this.feedata=res.data.data
					}
					
				});
			},	

		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.objectId = user.data.userId
			this.getPageList();
		}
	}

</script>

<style scoped>
	
	
</style>


// WEBPACK FOOTER //
// checkRecord.vue?2d2b60e8